/**
 * River Blocked Action Types
 *
 * Displayed when player tries to enter river rooms without boat.
 */

export const RIVER_BLOCKED_ACTION_ID = 'dungeo.action.river_blocked';

export const RiverBlockedMessages = {
  NO_BOAT: 'dungeo.river.no_boat'
} as const;
